import { X, AlertTriangle } from 'lucide-react';

interface DeactivateAccountModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isDeactivating: boolean;
}

export function DeactivateAccountModal({
  isOpen,
  onClose,
  onConfirm,
  isDeactivating,
}: DeactivateAccountModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm">
      <div className="bg-[#1A1F26] rounded-xl w-full max-w-md">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-white/[0.06]">
          <div className="flex items-center gap-3">
            <AlertTriangle className="text-orange-400" size={24} />
            <h2 className="text-xl font-semibold text-white">Deactivate Account</h2>
          </div>
          <button
            onClick={onClose}
            className="text-slate-400 hover:text-white transition-colors"
            disabled={isDeactivating}
          >
            <X size={24} />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          <p className="text-slate-300 mb-4">
            Your account will be deactivated and hidden from other users. You have 30 days to restore it.
          </p>
          <p className="text-sm text-slate-400 mb-6">
            After 30 days, your account and all data will be permanently deleted.
          </p>

          <div className="flex gap-3">
            <button
              onClick={onClose}
              disabled={isDeactivating}
              className="flex-1 px-4 py-2 bg-[#2A2F36] hover:bg-[#3A3F46] text-white rounded-lg transition-colors font-medium disabled:opacity-50"
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              disabled={isDeactivating}
              className="flex-1 px-4 py-2 bg-orange-500 hover:bg-orange-600 text-white rounded-lg transition-colors font-medium disabled:opacity-50"
            >
              {isDeactivating ? 'Deactivating...' : 'Deactivate'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
